import { applyMiddleware, createStore, compose } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import * as Sentry from "@sentry/react";

import reducer from './indexReducer';
import { attachBackendOverrideStore } from '../utils/backendOverride';

let store = null;

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

if (process.env.REACT_APP_ENV === 'PRODUCTION') {
  store = createStore(
    reducer,
    {},
    compose(applyMiddleware(thunk), sentryReduxEnhancer)
  );
}

if (process.env.REACT_APP_ENV === 'DEVELOPMENT') {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  store = createStore(
    reducer,
    {},
    composeEnhancers(applyMiddleware(thunk, logger), sentryReduxEnhancer)
  );
}

// The A/B backend routing reads companyId from this store at request time
// (attached here instead of imported there to avoid an import cycle).
attachBackendOverrideStore(store);

export default store;
